import DeleteIcon from '@/assets/all-icons/delete-icon';
import config from '@/config';

import '@/shared-components/forms/add-board-content/board-text-body/add-element/add-picture/BoardBodyPicture.css';

export default function BoardArtworkPreview({ image, caption, onClick, onRemove, sliderControls, previewMode = false }) {
  return (
    <div className={`board-artwork-preview-container${previewMode ? ' read-only' : ''}`}>
      <div className="post-image-with-caption">
        <div
          className="post-image-inline-container"
          
        >
          {onRemove && (
            <DeleteIcon
              className="post-image-inline-remove-button"
              onClick={onRemove}
            />
          )}
          <div className="image-wrapper">
            <img
              src={`${config.app.imageServiceDomain}/${image}/w=800`}
              srcSet={`
              ${config.app.imageServiceDomain}/${image}/w=400 400w,
              ${config.app.imageServiceDomain}/${image}/w=800 800w,
              ${config.app.imageServiceDomain}/${image}/w=1200 1200w,
              ${config.app.imageServiceDomain}/${image}/w=1600 1600w
            `}
              sizes="(max-width: 600px) 100vw, 600px"
              alt={caption}
              className="post-image-inline"
              onClick={!previewMode ? onClick : undefined}
              style={{ cursor: onClick && !previewMode ? 'pointer' : 'default' }}
            />
          </div>
        </div>
      </div>
      <p
        className="board-artwork-preview__caption"
        onClick={!previewMode ? onClick : undefined}
        style={{ cursor: onClick && !previewMode ? 'pointer' : 'default' }}
      >
        {caption}
      </p>

      {sliderControls && (
        <div className="inline-image-carousel__controls">
          {sliderControls}
        </div>
      )}
    </div>
  );
}
